import { getProfileOptions } from "@/api/queryOptions";
import { TrainingFile } from "@/components/shared/TrainingFile";
import { useSuspenseQuery } from "@tanstack/react-query";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";

const MyAcademyFiles = (): JSX.Element => {
	const { data: profile } = useSuspenseQuery(getProfileOptions);

	return (
		<div>
			<Accordion type="single" collapsible className="w-full">
				{profile?.resources.map((response, index) => {
					return (
						<AccordionItem key={response.id} value={`item-${index + 1}`}>
							<AccordionTrigger>
								{response.name}
							</AccordionTrigger>
							<AccordionContent>
								{response.media.map((element) => (
									<TrainingFile key={element.id} file={element} />
								))}
							</AccordionContent>
						</AccordionItem>
					);
				})}
			</Accordion>
		</div>
	);
};

export default MyAcademyFiles;
